/**
 * *************************************************************************************************************************
 * Monolithic file that holds the header component.
 * The reason for not componetizing this file lays in the fact that we are using th same header across our WP and v2Frontier
 * repo. It makes it much easier to copy & paste from header to header if both are self-contained. This header was
 * copied & pasted from the WP repo and tweaked accordingly to work with react. 🐺
 * *******************************************************************************
 * *
 *
 * @format
 */

import React, {useContext, useState} from 'react';
import {MegaMenuGraphics} from './megamenu_graphics';
import {MegaMenuCartons} from './megamenu_cartons';
import {MegaMenuLabels} from './megamenu_labels';
import {MegaMenuAbout} from './megamenu_about';
import {QuoteContext} from 'frontier-quoter';

import './header.scss';
import {MobileMenu} from 'frontier/ds/quoter/header/mobile_menu';

export const MOBILE_SECTION_LABELS = 1;
export const MOBILE_SECTION_CARTONS = 2;
export const MOBILE_SECTION_GRAPHICS = 3;
export const MOBILE_SECTION_ABOUT = 4;

export function Header() {
    const {cart} = useContext(QuoteContext);

    const topLevelLinks = {
        labels: '/labels',
        cartons: '/cartons',
        design: '/design',
        about: '/about',
        blog: '/blog',
        contact: '/contact',
        marketplace: '/marketplace',
        cart: '/cart',
        account: '/account'
    };

    // this state is in charge of toggling the classes
    const [isShowingMobile, setIsShowingMobile] = useState(false);
    // this one unmount/ mounts the mobile comp
    const [mobileMenuMounted, setMobileMenuMounted] = useState(false);
    // current megamenu in view for mobile
    const [currentOpenMegaMenuMobile, setCurrentOpenMegaMenuMobile] = useState(0);

    const handleOpenMenuMobile = () => {
        setIsShowingMobile(!isShowingMobile);

        if (!isShowingMobile) {
            setMobileMenuMounted(true);
            document.body.style.overflowY = 'hidden';
        } else {
            setTimeout(() => {
                setMobileMenuMounted(false);
            }, 300);

            document.body.style.overflowY = 'unset';
        }
    };

    return (
        <div data-beta="t" itemType="http://schema.org/LocalBusiness" className="mb-4">
            <div className="header-23cr">
                {/* Main nav containing the primary links */}
                <nav className="header-23cr_main-nav" aria-labelledby="main-nav">
                    <div className="header-23cr_container">
                        <div className="header-23cr_branding">
                            <a href="/">
                                <img
                                    className="branding-23cr_sttark-logo"
                                    itemProp="image"
                                    src="/assets/images/Sttark Logo-May2022.svg"
                                    alt="Sttark"
                                    height="40"
                                />
                                <meta itemProp="name" content="Sttark" />
                            </a>
                        </div>

                        {/* mobile */}
                        <section className="header-23cr_navigation--mobile">
                            <ul>
                                <li className="navigation-23cr_link-menu navigation-23cr_marketplace">
                                    <h6 className="marketplace-23cr_tag">New</h6>
                                    <a href={topLevelLinks['marketplace']}>
                                        <h6>Marketplace</h6>
                                    </a>
                                </li>
                                <li className="navigation-23cr_link-menu navigation-23cr_phone">
                                    <a href={topLevelLinks['contact']}>
                                        <img
                                            src="/images/icons/phone.svg"
                                            alt="icon of a phone for a menu option"
                                        />
                                    </a>
                                </li>
                                {!isShowingMobile && (
                                    <li className="navigation-23cr_link-menu navigation-23cr_account">
                                        <a href={topLevelLinks['account']}>
                                            <img
                                                src="/images/icons/account.svg"
                                                alt="icon of a profile user for a menu option"
                                            />
                                        </a>
                                    </li>
                                )}
                                {!isShowingMobile && (
                                    <li className="navigation-23cr_link-menu navigation-23cr_cart">
                                        <a href={topLevelLinks['cart']}>
                                            <img
                                                src="/images/icons/cart.svg"
                                                alt="icon of a cart for a menu option"
                                            />
                                            <span
                                                id="cart-total"
                                                data-cart_id={cart.id}
                                                data-total={cart.total}
                                                data-order_coun={cart.order_count}>
                                                <span className="cart-badge">
                                                    <b>{cart.order_count}</b>
                                                </span>
                                            </span>
                                        </a>
                                    </li>
                                )}

                                <li className="navigation-23cr_link-menu navigation-23cr_menu">
                                    <div
                                        className={`navigation-23cr_link-menu_burger ${
                                            isShowingMobile ? 'cross' : ''
                                        }`}
                                        onClick={handleOpenMenuMobile}>
                                        <span></span>
                                    </div>
                                </li>
                            </ul>
                        </section>

                        {/* desktop */}
                        <section
                            className="header-23cr_navigation"
                            aria-labelledby="mainmenulabel"
                            role="navigation">
                            <ul className="navigation-23cr_links">
                                <li
                                    className="navigation-23cr_link-menu navigation-23cr_labels"
                                    onMouseOver={() => {
                                        setCurrentOpenMegaMenuMobile(MOBILE_SECTION_LABELS);
                                        document.body.style.overflowY = 'hidden';
                                    }}
                                    onMouseLeave={() => {
                                        setCurrentOpenMegaMenuMobile(0);
                                        document.body.style.overflowY = 'unset';
                                    }}>
                                    <a href={topLevelLinks['labels']}>
                                        <h6>Labels</h6>
                                        <span className="link-23cr_carat">
                                            <svg
                                                width="8"
                                                height="5"
                                                viewBox="0 0 8 5"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path d="M0 0.166687L4 4.16669L8 0.166687H0Z" />
                                            </svg>
                                        </span>
                                    </a>
                                </li>
                                <li
                                    className="navigation-23cr_link-menu navigation-23cr_cartons"
                                    onMouseOver={() => {
                                        setCurrentOpenMegaMenuMobile(MOBILE_SECTION_CARTONS);
                                        document.body.style.overflowY = 'hidden';
                                    }}
                                    onMouseLeave={() => {
                                        setCurrentOpenMegaMenuMobile(0);
                                        document.body.style.overflowY = 'unset';
                                    }}>
                                    <a href={topLevelLinks['cartons']}>
                                        <h6>Cartons</h6>
                                        <span className="link-23cr_carat">
                                            <svg
                                                width="8"
                                                height="5"
                                                viewBox="0 0 8 5"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path d="M0 0.166687L4 4.16669L8 0.166687H0Z" />
                                            </svg>
                                        </span>
                                    </a>
                                </li>
                                <li
                                    className="navigation-23cr_link-menu navigation-23cr_graphics"
                                    onMouseOver={() => {
                                        setCurrentOpenMegaMenuMobile(MOBILE_SECTION_GRAPHICS);
                                        document.body.style.overflowY = 'hidden';
                                    }}
                                    onMouseLeave={() => {
                                        setCurrentOpenMegaMenuMobile(0);
                                        document.body.style.overflowY = 'unset';
                                    }}>
                                    <a href={topLevelLinks['design']}>
                                        <h6>Graphic Design</h6>
                                        <span className="link-23cr_carat">
                                            <svg
                                                width="8"
                                                height="5"
                                                viewBox="0 0 8 5"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path d="M0 0.166687L4 4.16669L8 0.166687H0Z" />
                                            </svg>
                                        </span>
                                    </a>
                                </li>
                                <li
                                    className="navigation-23cr_link-menu navigation-23cr_about"
                                    onMouseOver={() => {
                                        setCurrentOpenMegaMenuMobile(MOBILE_SECTION_ABOUT);
                                        document.body.style.overflowY = 'hidden';
                                    }}
                                    onMouseLeave={() => {
                                        setCurrentOpenMegaMenuMobile(0);
                                        document.body.style.overflowY = 'unset';
                                    }}>
                                    <a href={topLevelLinks['about']}>
                                        <h6>About</h6>
                                        <span className="link-23cr_carat">
                                            <svg
                                                width="8"
                                                height="5"
                                                viewBox="0 0 8 5"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path d="M0 0.166687L4 4.16669L8 0.166687H0Z" />
                                            </svg>
                                        </span>
                                    </a>
                                </li>
                                <li className="navigation-23cr_link-menu navigation-23cr_marketplace">
                                    <h6 className="marketplace-23cr_tag">New</h6>
                                    <a href={topLevelLinks['marketplace']}>
                                        <h6>Marketplace</h6>
                                    </a>
                                </li>
                                <li className="navigation-23cr_link-menu navigation-23cr_phone">
                                    <a href={topLevelLinks['contact']}>
                                        <img
                                            src="/images/icons/phone.svg"
                                            alt="icon of a phone for a menu option"
                                        />
                                    </a>
                                </li>
                                <li className="navigation-23cr_link-menu navigation-23cr_account">
                                    <a href={topLevelLinks['account']}>
                                        <img
                                            src="/images/icons/account.svg"
                                            alt="icon of a profile user for a menu option"
                                        />
                                    </a>
                                </li>
                                <li className="navigation-23cr_link-menu navigation-23cr_cart">
                                    <a href={topLevelLinks['cart']}>
                                        <img
                                            src="/images/icons/cart.svg"
                                            alt="icon of a cart for a menu option"
                                        />
                                        <span
                                            id="cart-total"
                                            data-cart_id={cart.id}
                                            data-total={cart.total}
                                            data-order_coun={cart.order_count}>
                                            <span className="cart-badge">
                                                <b>{cart.order_count}</b>
                                            </span>
                                        </span>
                                    </a>
                                </li>
                            </ul>
                        </section>
                    </div>
                </nav>

                {/* Labels Links */}

                <MegaMenuLabels
                    display={currentOpenMegaMenuMobile === MOBILE_SECTION_LABELS ? 'block' : 'none'}
                    onMouseOver={() => {
                        setCurrentOpenMegaMenuMobile(MOBILE_SECTION_LABELS);
                        document.body.style.overflowY = 'hidden';
                    }}
                    onMouseLeave={() => {
                        setCurrentOpenMegaMenuMobile(0);
                        document.body.style.overflowY = 'unset';
                    }}
                    isMobile={false}
                />

                {/* Cartons Links */}

                <MegaMenuCartons
                    display={
                        currentOpenMegaMenuMobile === MOBILE_SECTION_CARTONS ? 'block' : 'none'
                    }
                    onMouseOver={() => {
                        setCurrentOpenMegaMenuMobile(MOBILE_SECTION_CARTONS);
                        document.body.style.overflowY = 'hidden';
                    }}
                    onMouseLeave={() => {
                        setCurrentOpenMegaMenuMobile(0);
                        document.body.style.overflowY = 'unset';
                    }}
                    isMobile={false}
                />

                {/* Graphic Design Links */}

                <MegaMenuGraphics
                    display={
                        currentOpenMegaMenuMobile === MOBILE_SECTION_GRAPHICS ? 'block' : 'none'
                    }
                    onMouseOver={() => {
                        setCurrentOpenMegaMenuMobile(MOBILE_SECTION_GRAPHICS);
                        document.body.style.overflowY = 'hidden';
                    }}
                    onMouseLeave={() => {
                        setCurrentOpenMegaMenuMobile(0);
                        document.body.style.overflowY = 'unset';
                    }}
                    isMobile={false}
                />

                {/* About Links */}

                <MegaMenuAbout
                    display={currentOpenMegaMenuMobile === MOBILE_SECTION_ABOUT ? 'block' : 'none'}
                    onMouseOver={() => {
                        setCurrentOpenMegaMenuMobile(MOBILE_SECTION_ABOUT);
                        document.body.style.overflowY = 'hidden';
                    }}
                    onMouseLeave={() => {
                        setCurrentOpenMegaMenuMobile(0);
                        document.body.style.overflowY = 'unset';
                    }}
                    isMobile={false}
                />

                {/* Mobile menu */}
                {mobileMenuMounted && (
                    <MobileMenu
                        setCurrentOpenMegaMenuMobile={setCurrentOpenMegaMenuMobile}
                        currentOpenMegaMenuMobile={currentOpenMegaMenuMobile}
                        isShowingMobile={isShowingMobile}
                    />
                )}
            </div>
        </div>
    );
}
